var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-flow-box"},[_c('div',{class:{
      typeA: _vm.type === 'A',
      typeB: _vm.type === 'B',
    }},[_c('div',{staticClass:"outer"},[_c('div',{staticClass:"bar-box"},[_c('div',{staticClass:"bar-no"},[_c('p',[_vm._v(_vm._s(_vm.barNo))])]),_c('div',{staticClass:"bar-text"},[_c('p',[_vm._v(_vm._s(_vm.barText))])])]),_c('div',{staticClass:"answer"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.answer)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }